import type { Translations } from './zh';

export const en: Translations = {
  bubble: {
    open: 'Open chat',
    close: 'Close chat',
    badge: 'Online',
    dragHint: 'Long-press to drag',
  },
  panel: {
    closeAria: 'Close chat panel',
    languageAria: 'Select language',
    welcomeFallback: 'Hello, how can I help you?',
    quickQuestionsTitle: 'You can try asking me these questions',
    quickAskTitle: 'Quick questions',
    inputPlaceholder: 'Type your question...',
    sendButton: 'Send',
    sendAria: 'Send message',
    onlineStatus: 'Online',
    thinkingAria: 'Thinking',
    aiBusyHint: 'The agent is replying, please wait…',
    leadReopenHint: 'Leave your contact info here when needed',
    startChat: 'Start chatting',
    welcomeQuickHint: 'Quick start',
    videoPreparing: 'Preparing video, please wait…',
    newMessageTitle: '💬 New message',
    newMessageBody: 'You have a new message. Click to view.',
  },
  roles: {
    visitor: 'Visitor',
    ai: 'AI Assistant',
    human: 'Agent',
    system: 'System',
  },
  web: {
    aiChat: 'AI Support',
    humanChat: 'Human Agent',
    switchToHuman: 'Switch to Agent',
    switchToAI: 'Back to AI',
    resetChat: 'Reset Chat',
    commonQuestions: 'Common Questions',
    faqTitle: 'Frequently Asked Questions',
    selectLanguage: 'Select Language',
    maximize: 'Maximize',
    restore: 'Restore',
    offlineLabel: 'Offline',
    aiGreeting: "Hello! I'm your AI assistant. How can I help you today?",
    humanGreeting: "Hello, you're now connected to a human agent. How can I help you?",
    agentOffline: 'Agent Offline',
    agentOfflineMessage: 'Sorry, our agents are currently offline. Please scan the QR code below to add us on WeChat for assistance.',
    wechatPrompt: 'Scan to Add WeChat',
    wechatHint: 'Use WeChat to scan and add our agent',
    serviceHoursLabel: 'Service hours: ',
    viewImage: 'View image',
    playVideo: 'Play video',
    closeViewer: 'Close',
    downloadFile: 'Download',
    fileTypePdf: 'PDF document',
    fileTypeWord: 'Word document',
    fileTypeExcel: 'Excel spreadsheet',
    fileTypePpt: 'PowerPoint presentation',
    fileTypeArchive: 'Archive file',
    fileTypeGeneric: 'File',
  },
  leadCard: {
    ariaForm: 'Contact form',
    title: 'Leave your contact info',
    nameLabel: 'Name',
    namePlaceholder: 'Your name',
    phoneLabel: 'Phone',
    phonePlaceholder: 'Your phone number',
    phoneError: 'Please enter a valid phone number',
    submit: 'Submit',
    submitting: 'Submitting…',
    dismiss: 'Maybe later',
    success: 'Thanks! Our consultant will reach out to you soon.',
  },
};
